import { render, staticRenderFns } from "./3.vue?vue&type=template&id=038c05c0&scoped=true&"
import script from "./3.vue?vue&type=script&lang=js&"
export * from "./3.vue?vue&type=script&lang=js&"
import style0 from "./3.vue?vue&type=style&index=0&id=038c05c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038c05c0",
  null
  
)

export default component.exports